import { Button, Modal, Label, TextInput } from "flowbite-react";
import { useForm } from "react-hook-form";
import { UpdateReason } from "@/sharedTypes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface UpdateReasonFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: UpdateReason) => void;
  defaultValues?: UpdateReason;
  mode?: "create" | "edit";
  errorMessage?: string;
}

export default function UpdateReasonFormDialog({
  open,
  onClose,
  onSubmit,
  defaultValues,
  mode = "create",
  errorMessage,
}: UpdateReasonFormDialogProps) {
  const { t } = useTranslation(["updateReason", "common"]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<UpdateReason>();

  useEffect(() => {
    if (open) {
      reset(defaultValues || {
        update_reason_description: "",
      });
    }
  }, [open, defaultValues, reset]);

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>
        {mode === "edit" ? t("updateReason:edit") : t("updateReason:create")}
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="update_reason_description" value={t("updateReason:description")} />
            </div>
            <TextInput
              id="update_reason_description"
              placeholder={t("updateReason:descriptionPlaceholder")}
              {...register("update_reason_description", {
                required: t("updateReason:descriptionRequired"),
              })}
              color={errors.update_reason_description ? "failure" : "gray"}
              helperText={errors.update_reason_description?.message}
            />
          </div>

          {errorMessage && (
            <div className="text-sm text-red-500">{errorMessage}</div>
          )}
          
          <div className="flex justify-end gap-x-2">
            <Button color="gray" onClick={onClose}>
              {t("updateReason:cancel")}
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {mode === "edit" ? t("updateReason:save") : t("updateReason:add")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
